import BaseRepository from "~/repositories/BaseRepository";
import MediumWebPushNotificationModel from "~/models/MediumWebPushNotificationModel";

class MediumWebPushNotificationsRepository extends BaseRepository {
  async create(params = {}) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    const url = "/api/v1/readers/medium_web_push_notifications";
    const mediumWebPushNotificationModelParams = new MediumWebPushNotificationModel(params);
    await this._post(url, mediumWebPushNotificationModelParams.toApiParams());
  }
}
export default MediumWebPushNotificationsRepository;
